// extracted by mini-css-extract-plugin
export default {"duo":"DuoErrorScreen_duo__eu9at","wrap":"DuoErrorScreen_wrap__FcZEA"};